import { IsDefined, IsInt, IsString, Length, Max, Min } from 'class-validator';
import { DriverInformationBaseDto } from './driver-information-base.dto';

/**
 * DTO object for creation of DriverInformation.
 */
export class DriverInformationForCreateDto extends DriverInformationBaseDto {
  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  driverId: number;

  @IsString()
  @IsDefined()
  @Length(1, 250)
  driverLastName: string;

  @IsString()
  @IsDefined()
  @Length(1, 50)
  driverPhoneNumber: string;
}
